// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".read-only{padding-top:0}.read-only label{font-size:13px;font-weight:700;line-height:1.31;display:block;margin-bottom:4px}.read-only p{font-size:14px;font-weight:400;line-height:1.29;display:block;margin-bottom:0;word-break:break-word}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
